import { combineReducers } from 'redux';
import { fromJS } from 'immutable';
import getApiReducer from '../common/utils/getApiReducer';

import {
  ADD_COURSE,
  ADD_VIDEO_TO_COURSE,
  CREATE_QUIZ,
  DELETE_COURSE,
  DELETE_QUIZ,
  EDIT_COURSE,
  EDITING_QUIZ,
  FETCH_COURSES,
  GET_COURSE_VIDEO,
  GET_UNASSIGNED_BADGES,
  UPLOAD_COURSE_VIDEO,
  UPLOAD_COURSE_VIDEO_PROGRESS,
  GET_QUIZ,
  GET_DAILY_EXTRA,
  DELETE_DAILY_EXTRA,
  CREATE_DAILY_EXTRA,
} from './actions';

import { ADD_CHAPTER, EDIT_CHAPTER, DELETE_CHAPTER, FETCH_CHAPTERS, REORDER_CHAPTERS } from './chapters/actions';

import {
  ADD_LESSON,
  ADD_LESSON_VIDEO,
  DELETE_LESSON,
  EDIT_LESSON,
  FETCH_LESSONS,
  GET_LESSON_VIDEO,
  REORDER_LESSONS,
  UPLOAD_LESSON_VIDEO,
  UPLOAD_LESSON_VIDEO_PROGRESS,
} from './lessons/actions';

const chaptersReducer = getApiReducer(FETCH_CHAPTERS);
const chapters = (state, action) => {
  state = chaptersReducer(state, action);

  if (action.type === `${REORDER_CHAPTERS}_SUCCESS`) {
    return state.set('data', fromJS(action.json));
  }

  if (action.type === `${EDIT_CHAPTER}_SUCCESS`) {
    const data = state.get('data');
    const index = data.findIndex(item => item.get('id') === action.json.id);

    return state.set('data', data.set(index, fromJS(action.json)));
  }

  if (action.type === `${DELETE_CHAPTER}_SUCCESS`) {
    const data = state.get('data');
    const index = data.findIndex(item => item.get('id') === parseInt(action.chapterId, 10));

    return state.set('data', data.delete(index));
  }

  if (action.type === `${ADD_CHAPTER}_SUCCESS`) {
    return state.set('data', state.get('data').push(fromJS(action.json)));
  }

  return state;
};

const coursesReducer = getApiReducer(FETCH_COURSES);
const courses = (state, action) => {
  state = coursesReducer(state, action);

  if (action.type === `${DELETE_COURSE}_SUCCESS`) {
    const data = state.get('data');
    const index = data.findIndex(item => item.get('id') === action.id);

    state = state.set('data', data.delete(index));
  }

  if (action.type === `${EDIT_COURSE}_SUCCESS` || action.type === `${ADD_VIDEO_TO_COURSE}_SUCCESS`) {
    const data = state.get('data');
    const index = data.findIndex(item => item.get('id') === action.json.id);

    state = state.set('data', data.set(index, fromJS(action.json)));
  }

  if (action.type === `${ADD_COURSE}_SUCCESS`) {
    state = state.set('data', state.get('data').push(fromJS(action.json)));
  }

  if (action.type === `${GET_COURSE_VIDEO}_SUCCESS`) {
    const index = state.get('data').findIndex(item => item.get('id') === parseInt(action.courseId, 10));

    state = state.setIn(['data', index, 'video'], fromJS(action.json));
  }

  return state;
};

const lessonsReducer = getApiReducer(FETCH_LESSONS);
const lessons = (state, action) => {
  state = lessonsReducer(state, action);

  if (action.type === `${REORDER_LESSONS}_SUCCESS`) {
    return state.set('data', fromJS(action.json));
  }

  if (action.type === `${DELETE_LESSON}_SUCCESS`) {
    const data = state.get('data');
    const index = data.findIndex(item => item.get('id') === parseInt(action.lessonId, 10));

    return state.set('data', data.delete(index));
  }

  if (action.type === `${EDIT_LESSON}_SUCCESS` || action.type === `${ADD_LESSON_VIDEO}_SUCCESS`) {
    const data = state.get('data');
    const index = data.findIndex(item => item.get('id') === action.json.id);

    return state.set('data', data.set(index, fromJS(action.json)));
  }

  if (action.type === `${ADD_LESSON}_SUCCESS`) {
    return state.set('data', state.get('data').push(fromJS(action.json)));
  }

  if (action.type === `${GET_LESSON_VIDEO}_SUCCESS`) {
    const index = state.get('data').findIndex(item => item.get('id') === parseInt(action.lessonId, 10));
    return state.setIn(['data', index, 'video'], fromJS(action.json));
  }

  if (action.type === `${DELETE_QUIZ}_SUCCESS`) {
    const index = state.get('data').findIndex(item => item.get('id') === parseInt(action.lessonId, 10));
    return state.setIn(['data', index, 'quiz_id'], null);
  }

  if (action.type === `${CREATE_QUIZ}_SUCCESS`) {
    const index = state.get('data').findIndex(item => item.get('id') === parseInt(action.lessonId, 10));
    return state.setIn(['data', index, 'quiz_id'], action.json.id);
  }

  if (action.type === `${DELETE_DAILY_EXTRA}_SUCCESS`) {
    const index = state.get('data').findIndex(item => item.get('id') === parseInt(action.lessonId, 10));
    return state.setIn(['data', index, 'daily_extra_id'], null);
  }

  if (action.type === `${CREATE_DAILY_EXTRA}_SUCCESS`) {
    const index = state.get('data').findIndex(item => item.get('id') === parseInt(action.lessonId, 10));
    return state.setIn(['data', index, 'daily_extra_id'], action.json.id);
  }

  return state;
};

const previewUploadProgress = (state = { loaded: 0, total: 100 }, action) => {
  if (action.type === UPLOAD_COURSE_VIDEO_PROGRESS) {
    state = { loaded: action.loaded, total: action.total };
  }
  return state;
};

const previewUploading = (state = false, action) => {
  if (action.type === UPLOAD_COURSE_VIDEO) {
    state = action.uploading;
  }
  return state;
};

const lessonVideoUploadProgress = (state = { loaded: 0, total: 100 }, action) => {
  if (action.type === UPLOAD_LESSON_VIDEO_PROGRESS) {
    state = { loaded: action.loaded, total: action.total };
  }
  return state;
};

const lessonVideoUploading = (state = false, action) => {
  if (action.type === UPLOAD_LESSON_VIDEO) {
    state = action.uploading;
  }
  return state;
};

const quiz = getApiReducer(GET_QUIZ);
const badges = getApiReducer(GET_UNASSIGNED_BADGES);

const editingQuiz = (state = false, action) => {
  if (action.type === EDITING_QUIZ) {
    state = action.editing;
  }
  return state;
};

const dailyExtra = getApiReducer(GET_DAILY_EXTRA);

export default combineReducers({
  chapters,
  courses,
  lessons,
  badges,
  lessonVideoUploading,
  lessonVideoUploadProgress,
  previewUploadProgress,
  previewUploading,
  quiz,
  editingQuiz,
  dailyExtra,
});



// WEBPACK FOOTER //
// ./src/courses/reducers.js